import { atom, useAtom } from 'jotai';

type NotificationObject = {
  hasSignatureRequests?: boolean;
  hasQueueNotifications?: boolean;
};

const notificationObjAtom = atom<NotificationObject>({});

export const useSafeNotificationsObj = () => {
  const [notificationsObj, setNotificationsObj] = useAtom(notificationObjAtom);

  return {
    notificationsObj,
    setNotificationsObj,
  };
};
